import { Step, StepLabel, Stepper } from '@mui/material'

const STEPS = ['Find members', 'New team & validate', 'Review & apply']

/** The three-phase progress indicator across the top of the reassignment screen. */
const ReassignmentStepper = ({ activeStep }: { activeStep: number }) => (
  <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
    {STEPS.map(label => (
      <Step key={label}>
        <StepLabel>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
)

export default ReassignmentStepper
